/**
 * frontend/src/tabs/IvyTab.jsx
 * SoundDAO Sprint 6B follow-up — Full-screen Ivy experience (Creator home tab)
 *
 * Stub mirroring RexTab structure: centered reading column with inline
 * Chatbot.  Agent identity (Ivy · Publicist) is picked up automatically by
 * <Chatbot> from user.persona === 'creator'.  Stats strip intentionally
 * omitted until creator-specific metrics (posts, fans, streak) are defined
 * and wired up — product decision, tracked as a follow-up.
 *
 * Route: /creator/ivy (creator-persona gated in App.js)
 */

import React, { useEffect, useRef } from 'react';
import Chatbot from '../Chatbot';
import './RexTab.css';

export default function IvyTab({ user, session }) {
  const chatRef    = useRef(null);
  // Synchronous guard so StrictMode's double effect-fire doesn't
  // re-trigger openWithMessage for any pending onboarding handoff.
  const hasGreeted = useRef(false);

  useEffect(() => {
    if (hasGreeted.current) return;
    hasGreeted.current = true;
    const timer = setTimeout(() => {
      const pendingMsg = localStorage.getItem('sounddao_pending_chat_message');
      if (pendingMsg && chatRef.current) {
        localStorage.removeItem('sounddao_pending_chat_message');
        chatRef.current.openWithMessage(pendingMsg);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="rex-tab">
      <div className="rex-tab-container">
        {/* <Chatbot inline> renders its own AgentTabHeader at the top,
            driven by user.persona — creator → Ivy header. */}
        <Chatbot ref={chatRef} user={user} session={session} inline={true} />
      </div>
    </div>
  );
}
